// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { ExternalNetworkWithRelationsSchema } from './ExternalNetworkRelationsSchema'
import type { ExternalNetworkWithRelations } from './ExternalNetworkRelationsSchema'
import { StorageServiceSchema } from './StorageServiceSchema';

/////////////////////////////////////////
// STORAGE SERVICE RELATION SCHEMA
/////////////////////////////////////////

export type StorageServiceRelations = {
  surface: ExternalNetworkWithRelations;
};

export type StorageServiceWithRelations = z.infer<typeof StorageServiceSchema> & StorageServiceRelations

export const StorageServiceWithRelationsSchema: z.ZodType<StorageServiceWithRelations> = StorageServiceSchema.merge(z.object({
  surface: z.lazy(() => ExternalNetworkWithRelationsSchema),
}))